<div style="overflow-y:auto" class="container-fluid">
  <div class="flex-container row">
    <div class="flex-90" *ngIf='external == true'>
      You have successfully logged out. To login again, please click
      <a [routerLink]='["/login"]'>here</a>.
    </div>

    <div class="flex-90" *ngIf='external == false'>
      You have successfully logged off of the site.
      <br> Please remember to close your browser to ensure that any data used by this site is discarded.
      <br>
      <br> Thank you.
    </div>

  </div>
</div>